export const validField = (name, value) => {
  switch (name) {
    case "rank":
      return parseInt(value, 10) >= 1;
    case "question":
      return value.length >= 2;
    default:
      return true;
  }
};

export const validForm = (fields) => {
  const { rank, question } = fields;
  return parseInt(rank.value, 10) >= 1 && question.value.length >= 2;
};
